/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * HyusnSu Sim (hssim@rsupport.com)
 *
 * @description
 *
 * @created at Thu Mar 23 2023
 **/

import React from "react";
import { useTheme } from "@emotion/react";

import { dotStyle, hoverStyle, inputStyle, wrapperStyle } from "./private/emotion";

/**
 * @param checked 스위치 on/off 활성화 여부
 * @param disabled 비활성화 여부
 * @param onChange Change 함수
 * @param size 스위치 사이즈 ( TODO 스위치 사이즈 추가되면 작업 예정 )
 */

export interface SwitchProps extends React.HTMLAttributes<HTMLInputElement> {
	className?: string;
	checked?: boolean;
	disabled?: boolean;
	onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
	size?: "small" | "medium" | "large";
}

export default function Switch({
	className,
	checked = false,
	disabled = false,
	onChange,
	/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
	size = "small",
	...rest
}: SwitchProps) {
	const theme = useTheme();
	return (
		<div css={hoverStyle(theme, disabled)}>
			<div css={wrapperStyle(theme, checked, disabled)} className={className}>
				<div css={dotStyle(theme, checked)}></div>
				<input
					type="checkbox"
					css={inputStyle}
					onChange={onChange}
					checked={checked}
					disabled={disabled}
					{...rest}
				/>
			</div>
		</div>
	);
}
